const partner = () => {
    $partnerList = $(".partner-list")
    if (!$partnerList) return;

    $partnerList.on("mouseenter", ".partner-item", function () {
        if ($(this).hasClass("next-item")) return;
        $partnerList.find(".active").removeClass("active");
        $(this).addClass("active");
        const content = $(this).find(".content").html();
        //$(".partner-detail .content").html(content);
        $(".partner-detail .content").fadeOut(200, function () {
            $(this).html(content).fadeIn(200);
        });
    })

    //slick init
    $partnerList.on("init", function () {
        console.log($partnerList.find(".slick-current .partner-item").first())
        $partnerList.find(".slick-current .partner-item").first().trigger("mouseenter")
    })

    $partnerList.slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        arrows: false,
        infinite: true
    });
    $partnerList.on("click", ".next-item", function () {
        $partnerList.slick("slickNext");
    })


    $partnerList.on("afterChange", function () {
        $partnerList.find(".slick-current .partner-item").first().trigger("mouseenter")
    })
}

module.exports = partner
